import type { ReactNode } from "react"
import { segmentLabel, SEGMENT_NONE } from "../stores/drilldownFilters.store"
import { extractString } from "./drilldown-row"

export type ListColumnAlign = "left" | "right"

export interface ListColumnDef {
  /** Stable, unique key across the full rendered column list — used for colWidths state, colgroup/TableCell React keys, and resize targeting. */
  key: string
  /** Header content. `null` renders an empty header cell (e.g. the Creative column's hidden header). */
  header: ReactNode | null
  /** Initial/default width in px. */
  defaultWidth: number
  /** Header + cell text alignment. Omit for left (default). */
  align?: ListColumnAlign
  /** Exact TableCell className for this column — columns are not uniform (see DrilldownListView), so each owns its own class string. */
  cellClassName?: string
  /** Cell body for a given row. */
  renderCell: (row: Record<string, unknown>, index: number) => ReactNode
}

const GROUPBY_DEFAULT_WIDTH = 160

/**
 * Shared group-by ("segment") columns — identical row-shape (Groupby1/2/3) and
 * rendering logic for both competitors and My Brand modes, since both SQL builders
 * derive these columns from the same SEGMENT_OPTIONS values.
 */
export function buildGroupbyColumns(segment1: string, segment2: string, segment3: string): ListColumnDef[] {
  const slots: Array<{ key: string; segment: string; field: string }> = [
    { key: "groupby1", segment: segment1, field: "Groupby1" },
    { key: "groupby2", segment: segment2, field: "Groupby2" },
    { key: "groupby3", segment: segment3, field: "Groupby3" },
  ]

  return slots
    .filter((slot) => slot.segment !== SEGMENT_NONE)
    .map((slot) => ({
      key: slot.key,
      header: segmentLabel(slot.segment),
      defaultWidth: GROUPBY_DEFAULT_WIDTH,
      cellClassName: "overflow-hidden",
      renderCell: (row) => (
        <p className="truncate text-xs text-foreground">{extractString(row[slot.field]) || "—"}</p>
      ),
    }))
}
